import { CLOVER } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const TooltipContent: React.FC = () => {
  const { type, name: posCompanyName, locations } = usePOSSummary();

  const multiLocationText =
    type === CLOVER ? (
      <StrictLocalMsg
        defaultMessage="Stock count, synced from your connected {posCompanyName} account across all locations."
        description={{
          text: "Tooltip explaining the current inventory for a given product, refer to image",
          img: "https://cdn.faire.com/fastly/d640bf8c3d6c22e3a957f3fcf1afdef0c26c78e084cb1e9243c6230dec5588b9.png",
        }}
        values={{ posCompanyName }}
      />
    ) : (
      <StrictLocalMsg
        defaultMessage="Inventory in stock, synced from your connected {posCompanyName} account across all locations."
        description={{
          text: "Tooltip explaining the current inventory for a given product, refer to image",
          img: "https://cdn.faire.com/fastly/d640bf8c3d6c22e3a957f3fcf1afdef0c26c78e084cb1e9243c6230dec5588b9.png",
        }}
        values={{ posCompanyName }}
      />
    );

  const singleLocationText =
    type === CLOVER ? (
      <StrictLocalMsg
        defaultMessage="Stock count, synced from your connected {posCompanyName} account."
        description={{
          text: "Tooltip explaining the current inventory for a given product, refer to image",
          img: "https://cdn.faire.com/fastly/d640bf8c3d6c22e3a957f3fcf1afdef0c26c78e084cb1e9243c6230dec5588b9.png",
        }}
        values={{ posCompanyName }}
      />
    ) : (
      <StrictLocalMsg
        defaultMessage="Inventory in stock, synced from your connected {posCompanyName} account."
        description={{
          text: "Tooltip explaining the current inventory for a given product, refer to image",
          img: "https://cdn.faire.com/fastly/d640bf8c3d6c22e3a957f3fcf1afdef0c26c78e084cb1e9243c6230dec5588b9.png",
        }}
        values={{ posCompanyName }}
      />
    );

  return (
    <Typography color="inherit">
      {locations.length > 1 ? multiLocationText : singleLocationText}
    </Typography>
  );
};
